<div class="justup-dialog">
  <vl-dialog-header-export
    [exporting]="exporting()"
    (close)="dialogRef.close()"
    (export)="exportExcel()"
  >
    Évolution prix d'achat — {{ data.articleDenomination }}
  </vl-dialog-header-export>

  <div class="justup-dialog-content flex-col gap-16">
    <!-- ViewMode toggle -->
    <div class="flex-row justify-center">
      <vl-chips-toggle [elements]="viewModeElements" [(value)]="viewMode" size="small"/>
    </div>

    <!-- Stats cards -->
    <div class="flex-row gap-8 wrap">
      <vl-radio-card mode="display" color="valid" icon="euro"
                     [title]="'PU moyen'"
                     style="flex: 1; min-width: 140px">
        <div content class="flex-col gap-2">
          <span class="headline">{{ stats().puMoyen | number:'1.2-2' }} €</span>
          <span class="tiny" style="opacity: 0.7">/ {{ data.articleUniteGestion || 'UG' }}</span>
        </div>
      </vl-radio-card>

      <vl-radio-card mode="display" color="secondary" icon="swap_vert"
                     [title]="'Min / Max'"
                     style="flex: 1; min-width: 140px">
        <div content class="flex-col gap-2">
          <span class="headline">{{ stats().puMin | number:'1.2-2' }} € <span class="tiny" style="opacity: 0.6">→</span> {{ stats().puMax | number:'1.2-2' }} €</span>
        </div>
      </vl-radio-card>

      <vl-radio-card mode="display" [color]="variationColor()" icon="trending_up"
                     [title]="'Variation'"
                     style="flex: 1; min-width: 140px">
        <div content class="flex-col gap-2">
          <span class="headline">
            @if (stats().variation > 0) { + }
            {{ stats().variation | number:'1.1-1' }}%
          </span>
          <span class="tiny" style="opacity: 0.7">1er → dernier</span>
        </div>
      </vl-radio-card>

      <vl-radio-card mode="display" color="basic" icon="receipt_long"
                     [title]="'Commandes'"
                     style="flex: 1; min-width: 140px">
        <div content class="flex-col gap-2">
          <span class="headline">{{ stats().nbCommandes }}</span>
          <span class="tiny" style="opacity: 0.7">{{ stats().qtyTotale | number:'1.0-0' }} {{ data.articleUniteGestion || 'UG' }}</span>
        </div>
      </vl-radio-card>

      <vl-radio-card mode="display" color="warn" icon="payments"
                     [title]="'Coût total'"
                     style="flex: 1; min-width: 140px">
        <div content class="flex-col gap-2">
          <span class="headline">{{ stats().coutTotalFormatted }}</span>
        </div>
      </vl-radio-card>
    </div>

    @if (data.tiersId || data.articleId) {
      <div class="nc-section justup-card-aside container-background-reverse-alt p-12">
        <vl-nc-aside-block
          [tiersId]="data.tiersId"
          [articleId]="data.articleId"
          [showCostSummary]="true"
          [includeAll]="true"
          title="Non-conformités sur cet axe"
          data-testid="nc-aside-achat-dialog"/>
      </div>
    }

    @if (viewMode() === 'byCommande') {
      <!-- Header -->
      <div class="flex-row gap-8 p-8 align-center"
           style="padding-right: 12px; border-bottom: 1px solid var(--color-on-disabled)">
        <span class="shrink-0" style="width: 16px"></span>
        <span class="grow tiny on-background-alt"
              style="font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
          Commande
        </span>
        <span class="tiny on-background-alt shrink-0"
              style="min-width: 80px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
          Qté
        </span>
        <span class="tiny on-background-alt shrink-0"
              matTooltip="Prix unitaire d'achat moyen (pondéré par quantité)"
              style="min-width: 70px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
          PU
        </span>
        <span class="tiny on-background-alt shrink-0"
              matTooltip="Coût total HT"
              style="min-width: 80px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
          Coût
        </span>
      </div>

      @for (c of sortedCommandes(); track c.commandeId) {
        <div>
          <div class="flex-row gap-8 p-8 align-center border-box border-8 cursor-pointer"
               style="border: 1px solid var(--color-outline)"
               (click)="toggle(c.commandeId)">
            <mat-icon class="on-disabled shrink-0" style="font-size: 16px; width: 16px; height: 16px">
              {{ isOpen(c.commandeId) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
            <div class="grow flex-col" style="min-width: 0">
              <span class="caption on-background-alt" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ c.numero }}</span>
              <span class="tiny on-disabled">{{ formatDate(c.dateKey) }}</span>
            </div>
            <span class="tiny on-background-alt shrink-0" style="min-width: 80px; text-align: right">
              {{ c.qtyUG | number:'1.0-2' }} {{ data.articleUniteGestion || 'UG' }}
            </span>
            <span class="shrink-0 pu-badge" [style.background-color]="colorForPU(c.puAchatMoyen)" style="min-width: 70px; text-align: right">
              {{ c.puAchatMoyen | number:'1.2-2' }} €
            </span>
            <span class="tiny on-disabled shrink-0" style="min-width: 80px; text-align: right">
              {{ c.coutTotal | number:'1.0-0' }} €
            </span>
          </div>

          @if (isOpen(c.commandeId) && c.lots.length) {
            <div class="flex-col gap-2 mt-2 mb-2" style="margin-left: 24px">
              @for (lot of c.lots; track lot.lotNumero) {
                <div class="flex-row gap-12 p-8 border-on-disabled border-box border-8">
                  <div class="flex-col gap-4 grow" style="min-width: 0">
                    @if (lot.lotId) {
                      <vl-lot-card [lotId]="lot.lotId" mode="text"/>
                    } @else {
                      <span class="caption on-background-alt" style="font-weight: 600">
                        {{ lot.lotNumero || '— lot inconnu —' }}
                      </span>
                    }
                    <div class="flex-row gap-4 align-baseline">
                      <span class="tiny on-disabled" style="min-width: 60px">Achat</span>
                      <span class="tiny on-background-alt">{{ lot.qtyUG | number:'1.0-2' }} {{ lot.uniteGestion }} × {{ lot.puAchat | number:'1.2-2' }} €</span>
                    </div>
                  </div>
                  <div class="flex-col gap-2 shrink-0 align-end justify-center">
                    <span class="pu-badge" [style.background-color]="colorForPU(lot.puAchat)">
                      {{ lot.puAchat | number:'1.2-2' }} €
                    </span>
                    <span class="tiny on-disabled">{{ lot.coutTotal | number:'1.0-0' }} €</span>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    } @else {
      <!-- Header mois -->
      <div class="flex-row gap-8 p-8 align-center"
           style="padding-right: 12px; border-bottom: 1px solid var(--color-on-disabled)">
        <span class="grow tiny on-background-alt"
              style="font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
          Mois
        </span>
        <span class="tiny on-background-alt shrink-0"
              style="min-width: 50px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
          Nb
        </span>
        <span class="tiny on-background-alt shrink-0"
              style="min-width: 80px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
          Qté
        </span>
        <span class="tiny on-background-alt shrink-0"
              style="min-width: 70px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
          PU moy.
        </span>
        <span class="tiny on-background-alt shrink-0"
              style="min-width: 80px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
          Coût
        </span>
      </div>

      @for (m of monthRows(); track m.monthKey) {
        <div class="flex-row gap-8 p-8 align-center border-box border-8"
             style="border: 1px solid var(--color-outline)">
          <span class="grow caption on-background-alt" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
            {{ m.monthLabel }}
          </span>
          <span class="tiny on-disabled shrink-0" style="min-width: 50px; text-align: right">{{ m.nbCommandes }}</span>
          <span class="tiny on-background-alt shrink-0" style="min-width: 80px; text-align: right">
            {{ m.qtyUG | number:'1.0-2' }} {{ data.articleUniteGestion || 'UG' }}
          </span>
          <span class="shrink-0 pu-badge" [style.background-color]="colorForPU(m.puAchatMoyen)" style="min-width: 70px; text-align: right">
            {{ m.puAchatMoyen | number:'1.2-2' }} €
          </span>
          <span class="tiny on-disabled shrink-0" style="min-width: 80px; text-align: right">
            {{ m.coutTotal | number:'1.0-0' }} €
          </span>
        </div>
      }
    }
  </div>
</div>
